const STORAGE_PREFIX = "adatis_establishment_signature_v1";

const storageKey = (tenantId: number | string, userId: number | string): string =>
  `${STORAGE_PREFIX}:${tenantId}:${userId}`;

export const loadEstablishmentSignature = (
  tenantId: number | string | null | undefined,
  userId: number | string | null | undefined
): string | null => {
  if (tenantId == null || userId == null || typeof window === "undefined") {
    return null;
  }

  try {
    const value = window.localStorage.getItem(storageKey(tenantId, userId));
    return value && value.startsWith("data:image/") ? value : null;
  } catch {
    return null;
  }
};

export const saveEstablishmentSignature = (
  tenantId: number | string | null | undefined,
  userId: number | string | null | undefined,
  dataUrl: string | null
): void => {
  if (tenantId == null || userId == null || typeof window === "undefined") {
    return;
  }

  try {
    const key = storageKey(tenantId, userId);
    if (!dataUrl) {
      window.localStorage.removeItem(key);
      return;
    }
    window.localStorage.setItem(key, dataUrl);
  } catch {
    // Quota / private mode — ignore silently.
  }
};
